<div class="dashboard-container" *ngIf="!isComingSoon">
  <!-- <div class="create-post-section">
          <div class="create-post-container">
            <img [src]="'assets/images/user-profile.jpg'" alt="User Avatar" class="user-avatar" />
            <input type="text" class="create-post-input" placeholder="Start a post" />
            <button class="post-button">Post</button>
          </div>
          <div class="create-post-actions">
            <button class="action-button">
              <i class="bi bi-image"></i> Media
            </button>
            <button class="action-button">
              <i class="bi bi-calendar-event"></i> Event
            </button>
            <button class="action-button">
              <i class="bi bi-file-earmark-text"></i> Write article
            </button>
          </div>
      </div> -->

  <div *ngFor="let post of posts" class="post-card">
    <div class="post-header">
      <img [src]="post.user.avatar" alt="User Avatar" class="user-avatar" />
      <div class="user-info">
        <h3 class="user-name">{{ post.user.name }}</h3>
        <p class="user-title">{{ post.user.title }}</p>
        <a href="#" class="user-website">{{ post.user.website }}</a>
      </div>
      <!-- <button class="follow-button">+ Follow</button> -->
    </div>

    <div class="post-content">
      <p>{{ post.content }}</p>
    </div>

    <div class="post-footer">
      <div class="post-actions">
        <button class="action-button">
          <i class="bi bi-heart"></i> Like
        </button>
        <button class="action-button" (click)="toggleComments(post)">
          <i class="bi bi-chat"></i> Comment
        </button>
        <button class="action-button">
          <i class="bi bi-arrow-repeat"></i> Repost
        </button>
        <!-- <button class="action-button">
              <i class="bi bi-envelope"></i> Send
            </button> -->
      </div>
      <div class="post-stats">
        <span class="stat-item">{{ post.likes }} likes</span>
        <span class="stat-item">{{ post.comments.length }} comments</span>
        <span class="stat-item">{{ post.shares }} reposts</span>
      </div>
    </div>

    <div class="comments-section" *ngIf="post.showComments">
      <div class="create-post-section">
        <div class="create-post-container">
          <img [src]="'assets/images/user-profile.jpg'" alt="User Avatar" class="user-avatar" />
          <input type="text" class="create-post-input" placeholder="Start a comment" />
          <button class="post-button">Comment</button>
        </div>
      </div>
      <div *ngFor="let comment of post.comments | slice: 0:post.visibleCommentsCount" class="comment">
        <div class="comment-header">
          <img [src]="comment.avatar" alt="User Avatar" class="comment-avatar" />
          <div class="comment-user-info">
            <p class="comment-user-name">{{ comment.user }}</p>
            <p class="comment-timestamp">{{ comment.timestamp }}</p>
          </div>
        </div>
        <p class="comment-text">{{ comment.text }}</p>
      </div>
      <button *ngIf="post.comments.length > post.visibleCommentsCount" class="load-more-button"
        (click)="loadMoreComments(post)">
        Load more comments
      </button>
    </div>
  </div>
</div>

<ng-container *ngIf="isComingSoon">
  <div class="coming-soon-card">
    <div class="icon-container">
      <i class="bi bi-clock-history" style="font-size: 48px; color: #3b82f6;"></i>
    </div>
    <h3 class="message-title">Coming Soon</h3>
    <p class="message-text">
      This dashboard is under development and will be available soon. Stay tuned for updates!
    </p>
  </div>
</ng-container>